import { render, staticRenderFns } from "./SuspiciousGroupJoinReported.vue?vue&type=template&id=75306b0c&scoped=true&"
import script from "./SuspiciousGroupJoinReported.vue?vue&type=script&lang=js&"
export * from "./SuspiciousGroupJoinReported.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousGroupJoinReported.vue?vue&type=style&index=0&id=75306b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75306b0c",
  null
  
)

export default component.exports